import { Component } from '@angular/core';
import { ButtonColor } from '@freelancer/ui/button';

@Component({
  selector: 'app-navigation-secondary-showcase',
  template: `
    <app-bar flTrackingSection="SubnavShowcase">
      <app-bar-item
        link="/showcase"
        i18n="Secondary navigation showcase bar item"
        flTrackingLabel="Showcase"
      >
        Showcase
      </app-bar-item>
      <app-bar-item
        link="/community"
        i18n="Secondary navigation showcase bar item"
        flTrackingLabel="Community"
      >
        Community
      </app-bar-item>
      <app-bar-item link="/showcase/my"
        [exactLink]="true"
        i18n="Secondary navigation showcase bar item"
        flTrackingLabel="MyShowcases"
      >
        My Showcases
      </app-bar-item>
      <fl-button
        [color]="ButtonColor.PRIMARY"
        link="/post-project"
        i18n="Secondary navigation showcase bar post project button"
        flTrackingLabel="PostProjectButton"
      >
        Post a Project
      </fl-button>
    </app-bar>
  `,
})
export class NavigationSecondaryShowcaseComponent {
  ButtonColor = ButtonColor;
}
